export const UPDATE_IMAGE_GALLERY_DISMISS = "UPDATE_IMAGE_GALLERY_DISMISS";
